<div class="contact-container">
    <mat-card class="contact-card-container">
        <mat-card-content>
            <div class="contact-title-container">
                <span>
                    Please provide us with your contact information in case we need to follow-up with you.
                </span>
            </div>
            <form [formGroup]="Form" (ngSubmit)="OnSubmit()">
                <div>
                    <div class="tile-content">
                        <enterprise-text-input  #Name
                                                [InputId]="'contact-information-input-username'"
                                                [InputName]="'userName'"
                                                Label="Name of Person Completing this Form"
                                                formControlName="userName"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('userName', 'Name of Person')"
                                                [MaxLength]="UserNameMaxLength"
                                                [Appearance]="'outline'">
                        </enterprise-text-input>
                        <app-input-phone [Label]="'Daytime Phone Number'"
                                         [Form]="Form"
                                         [FormControlName]="'dayTimePhone'"
                                         [ButtonDisabled]="true"
                                         [ShowButton]="false"
                                         [InputId]="'contact-information-input-dayTimePhone'"
                                         [InputName]="'dayTimePhone'">
                        </app-input-phone>
                        <enterprise-text-input  #Email
                                                [InputId]="'contact-information-input-email'"
                                                [InputName]="'email'"
                                                Label="E-mail Address"
                                                formControlName="email"
                                                [MaxLength]="EmailMaxLength"
                                                [Appearance]="'outline'">
                        </enterprise-text-input>
                        <div class="contact-button-container">
                            <button mat-raised-button
                                type="submit"
                                class="mat-flat-button mat-primary btn-sm">
                                <mat-icon>arrow_forward_ios</mat-icon>
                                Next
                            </button>
                        </div>
                        <p class="contact-footer-container">
                            <span>
                                The Web Questionnaire is not directed toward persons under 18 years of age. We do not knowingly market to or collect any personal information from children
                                under the age of 18 through the internet. If you are under 18, you are not permitted to submit any personal information to us through this site.
                                If you provide information to us through the Web Questionnaire, you represent that you are 18 years of age or older.
                            </span>
                        </p>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>
